import React, { useState, useCallback} from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useSwipeable } from "react-swipeable";
import styled from "styled-components";

// Ana kapsayıcıyı styled-components ile oluşturuyoruz
const Container = styled.div`
  touch-action: pan-y;
  width: 100%;
  height: 100%;
  flex: 1;
  padding-top: 16px;
  .react-tabs{
    height: 100%;
    ul{
      li{
        font-size: 12px;
      }
    }
  }
`;



// Sekme listesini stillendirme
const StyledTabList = styled(TabList)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 46px;
  background: linear-gradient(360deg, #876BC6 0%, #7859C1 55.98%, #6E4EBB 111.96%);
  border-radius: 100px;
  margin-bottom: 8px;
  border: 1px solid #FFFFFF;
  backdrop-filter: blur(10px);
  box-shadow: 0px 4px 0px 0px #6747AC;
  padding: 0 4px;

`;

// Sekmeleri stillendirme
const StyledTab = styled(Tab)`
  color: white;
  cursor: pointer;
  font-weight: bold;
  border-radius: 100px;
  list-style: none;
  background: transparent;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  height: 90%;
  outline: none;
  &:hover {
    background:rgba(75, 52, 134, 0.44);
  }

  &.react-tabs__tab--selected {
    background: white;
    color: #4B3486;
  }
`;

// İçerik panelini stillendirme
const StyledTabPanel = styled(TabPanel)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  color: white;
  transition: opacity 0.3s ease-in-out;
  &.react-tabs__tab-panel--selected{
    height: calc(100% - 56px); // padding + tabs height
  }
  &[hidden] {
    display: none;
  }
`;

const SwipeableTabs = ({ tabs, children }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleSwipe = useCallback(
    (direction) => {
      setSelectedIndex((prev) => {
        const nextIndex = direction === "left" ? prev + 1 : prev - 1;
        return Math.min(Math.max(nextIndex, 0), tabs.length - 1);
      });
    },
    [tabs.length]
  );

  const handlers = useSwipeable({
    onSwipedLeft: () => handleSwipe("left"),
    onSwipedRight: () => handleSwipe("right"),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
    delta: 50, // Yanlışlıkla kaydırmayı önlemek için eşik değer
  });

  return (
    <Container {...handlers}>
      <Tabs selectedIndex={selectedIndex} onSelect={setSelectedIndex}>
        <StyledTabList>
          {tabs.map((tab, index) => (
            <StyledTab key={index}>{tab}</StyledTab>
          ))}
        </StyledTabList>

        {React.Children.map(children, (child, index) => (
          <StyledTabPanel key={index}>{child}</StyledTabPanel>
        ))}
      </Tabs>
    </Container>
  );
};

export default SwipeableTabs;
